import React from "react";
import imageSeaside from "../../../assets/img/directsearch/seaside.avif";
import imageMountains from "../../../assets/img/directsearch/mountains.avif";
import imageCity from "../../../assets/img/directsearch/city.avif";
import imageLake from "../../../assets/img/directsearch/lake.avif";
import imageHinterland from "../../../assets/img/directsearch/hinterland.avif";
import imageWellness from "../../../assets/img/directsearch/wellness.avif";
import { useSearch } from "../../hooks/useSearch";
import { useTranslation } from "react-i18next";
import {
  ANALYTICS_SEARCH_TYPE,
  ANALYTICS_SOURCE,
} from "../../../config/analytics";

const directSearchCategories = [
  {
    key: "sea",
    image: imageSeaside,
    label: "destination_category_sea",
  },
  {
    key: "mountain",
    image: imageMountains,
    label: "destination_category_mountain",
  },
  {
    key: "city",
    image: imageCity,
    label: "destination_category_city",
  },
  {
    key: "lake",
    image: imageLake,
    label: "destination_category_lake",
  },
  {
    key: "countryside",
    image: imageHinterland,
    label: "destination_category_countryside",
  },
  {
    key: "wellness",
    image: imageWellness,
    label: "destination_category_wellness",
  },
] as const;

const TagsCarousel = () => {
  const { searchParameters, goToSearchUrl } = useSearch();
  const { t } = useTranslation();
  return (
    <>
      <ul className="flex overflow-x-auto snap-x gap-3 w-screen lg:w-full -translate-x-4 list-none mb-0 pb-4">
        {directSearchCategories.map((tag, index) => (
          <li
            key={`card-${index}-${tag.key}`}
            className="flex flex-col min-w-[200px] w-[200px] gap-2 cursor-pointer"
            onClick={() => {
              goToSearchUrl(
                {
                  ...searchParameters,
                  placeId: undefined,
                  collectionId: undefined,
                  searchType: "tag",
                  destinationLabel: undefined,
                  tag: tag.key,
                  searchLocationType: undefined,
                },
                {
                  reset: true,
                  triggerTagManagerEvent: true,
                  source: ANALYTICS_SOURCE.LIST,
                  searchType: ANALYTICS_SEARCH_TYPE.TAG,
                },
              );
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <div className="border border-[#E8E8E8] p-1 rounded-2xl shadow aspect-square w-full">
              <img
                src={tag.image}
                alt={t(`ds.${tag.label}`)}
                className="w-full rounded-xl h-full aspect-square"
              />
            </div>
            <div className="flex flex-col p-1">
              <p className="font-medium truncate text-ellipsis text-center">
                {t(`ds.${tag.label}`)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default TagsCarousel;
